// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module__list___1n6gL","button":"styles-module__button___2Z46a","active":"styles-module__active___3oyxJ","big":"styles-module__big___1eRCh"};